import React, { useState } from "react";
//import slugify from "slugify";

function Checkbox({ response, onChange }) {
  const [value, setValue] = useState(response.value);
  console.log("response.value", value)
  return (
    <div className="form-group">
      <div className="row">This field is not editable</div>
      {/* <input
          className="form-control"
          type="checkbox"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
        >
         {value}
        </input> */}
    </div>
  );
}

export default Checkbox;
